export var XfinityVariant;
(function (XfinityVariant) {
    XfinityVariant[XfinityVariant["X1"] = 1] = "X1";
    XfinityVariant[XfinityVariant["XClass"] = 2] = "XClass";
    XfinityVariant[XfinityVariant["Xumosb"] = 3] = "Xumosb";
})(XfinityVariant || (XfinityVariant = {}));
export var XfinityPartner;
(function (XfinityPartner) {
    XfinityPartner["COMCAST"] = "COMCAST";
    XfinityPartner["XGLOBAL"] = "XGLOBAL";
})(XfinityPartner || (XfinityPartner = {}));
//# sourceMappingURL=xfinity-types.js.map